bz_app.factory('geolocationService', [
  '$rootScope',
  function ($rootScope) {
    var locationService = {
      location_key: 'user_location_data',
      saveLocation: function (location) {
        if (typeof Storage !== 'undefined') {
          localStorage.setItem(
            this.location_key,
            JSON.stringify({
              created_at: Date.now(),
              latitude: location.latitude,
              longitude: location.longitude,
            })
          )
          return true
        } else {
          return false
        }
      },
      getLocationFromStorage: function () {
        if (typeof Storage !== 'undefined') {
          return JSON.parse(localStorage.getItem(this.location_key))
        } else {
          return null
        }
      },
      getLocationFromGPS: function (callback) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            function (position) {
              if (callback !== undefined)
                locationService.saveLocation(position.coords)
              callback(position)
            },
            function (error) {
              var error_message = ''
              var defaultErrorMessage =
                'We had a problem identifying your location.'
              switch (error.code) {
                case error.PERMISSION_DENIED:
                  error_message =
                    'We were not allowed to identify your location.'
                  break
                case error.POSITION_UNAVAILABLE:
                  error_message = defaultErrorMessage
                  break
                case error.TIMEOUT:
                  error_message = defaultErrorMessage
                  break
                case error.UNKNOWN_ERROR:
                  error_message = defaultErrorMessage
                  break
              }
              var device = isMobile.check() ? 'phone' : 'browser'
              var warning =
                'We are unable to geolocate your position.  Please check your ' +
                device +
                "'s settings and ensure that location services are enabled."
              alert(warning)
              $rootScope.$broadcast('user_location_set_error', {
                message: error_message,
              })
            }
          )
        }
      },
    }
    return locationService
  },
])
